// Subscribe.js
import React, { useState } from "react";
import {
  Box, Button, Grid, Typography, Card, CardContent,
  ToggleButton, ToggleButtonGroup
} from "@mui/material";
import { useAuth } from "../AuthContext";
import axios from "axios";

const pricingPlans = {
  monthly: [
    { name: "Basic", tier: "basic monthly", price: "$10/mo", features: ["5 reports/month", "Basic charts"] },
    { name: "Pro", tier: "pro monthly", price: "$20/mo", features: ["50 reports/month", "Advanced charts", "Export CSV"] },
    { name: "Enterprise", tier: "enterprise monthly", price: "$50/mo", features: ["Unlimited access", "Premium support", "Custom dashboards"] },
  ],
  yearly: [
    { name: "Basic", tier: "basic annual", price: "$100/yr", features: ["5 reports/month", "Basic charts"] },
    { name: "Pro", tier: "pro annual", price: "$200/yr", features: ["50 reports/month", "Advanced charts", "Export CSV"] },
    { name: "Enterprise", tier: "enterprise annual", price: "$500/yr", features: ["Unlimited access", "Premium support", "Custom dashboards"] },
  ]
};

export default function Subscribe() {
  const { user } = useAuth();
  const [billing, setBilling] = useState("monthly");

  const handleSubscribe = async (tier) => {
  if (!user) {
    alert("Please log in first.");
    return;
  }

  try {
    const token = await user.getIdToken();
    console.log("Sending tier:", tier);
    console.log("Email:", user.email);
    console.log("UID:", user.uid);
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/create-checkout-session`, {
      email: user.email,
      uid: user.uid || undefined,
      tier: tier,
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });

    if (response.data.url) {
      window.location.href = response.data.url;
    } else {
      alert("Failed to create checkout session.");
    }
  } catch (err) {
    console.error(err);
    alert("Error initiating subscription.");
  }
};

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" textAlign="center" gutterBottom>
        Choose Your Plan
      </Typography>

      <Box textAlign="center" mb={4}>
        <ToggleButtonGroup
          value={billing}
          exclusive
          onChange={(e, value) => value && setBilling(value)}
        >
          <ToggleButton value="monthly">Monthly</ToggleButton>
          <ToggleButton value="yearly">Annually (Save 20%)</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Grid container spacing={4} justifyContent="center">
        {pricingPlans[billing].map((plan) => (
          <Grid item xs={12} sm={6} md={4} key={plan.name}>
            <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
              <CardContent>
                <Typography variant="h6" textAlign="center">{plan.name}</Typography>
                <Typography variant="h4" textAlign="center" color="primary" gutterBottom>
                  {plan.price}
                </Typography>
                <ul>
                  {plan.features.map((f, i) => (
                    <li key={i}><Typography variant="body2">{f}</Typography></li>
                  ))}
                </ul>
                <Button
                  fullWidth
                  variant="contained"
                  sx={{ mt: 2 }}
                  onClick={() => handleSubscribe(plan.tier)}
                >
                  Subscribe
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
